import { createProvider } from '@frontend/store';
import { FormsSubmissionDetailsV2Store } from './types';

export const { Provider: FormsSubmissionDetailsV2StoreProvider, useStore: useFormsSubmissionDetailsV2Store } =
  createProvider<FormsSubmissionDetailsV2Store>()((set) => ({
    activeFormId: '',
    setActiveFormId: (activeFormId) => set({ activeFormId }),
  }));
